import { useContext } from "react";
import UserContext from "../Contexts/UserContext";
import EmployeeLeaveRequests from "./EmployeeLeaveRequests";
import ManagerLeaveRequests from "./ManagerLeaveRequests";
import AdminLeaveRequests from "./AdminLeaveRequests";

export const LeaveRequests = () => {
  const { user } = useContext(UserContext);

  if (user.Role === "admin" || user.Role === "tgs-admin") {
    return <AdminLeaveRequests />;
  } else if (user.Role === "manager" || user.Role === "hiring manager") {
    return <ManagerLeaveRequests />;
  } else {
    return <EmployeeLeaveRequests />;
  }
};